module.exports = __webpack_public_path__ + "eecccf82442b919a15c457be4a2c1b22.svg";